import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-product-with-variant.js';
const html = `
<div class="container-fallback">
  <div class="wrap-card">
    <div class="wrap-card-title">
      <div class="swiper-button-prev"></div>
      <div data-attribute="card-title" data-show="true" class="card-title" style="display: block;">
        <h2>Best Sellers</h2>
      </div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="wrap-block-products">
      <div class="swiper">
        <div data-attribute="list-item" data-col-perview="4" data-space-between="25" class="swiper-wrapper"
          style="--col-perview: 4; --space-between: 25px;">
          <div data-attribute="product-item" class="swiper-slide">
            <div class="wrap-product">
              <div class="block-imgs-product">
                <a href="#" data-attribute="list-img-color-variant" class="wrap-images">
                  <div data-attribute="color-variant" data-color="#FFC0CB" data-color-variant="pink" data-active="true"
                    class="color-variant active">
                    <div class="wrap-img-color active">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df46f249b7a542084dc9.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df4a41a1725b8ce3827f.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#d5a596" data-color-variant="peach"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17bdb2d8fc424333f7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17e89bbe7a9e5772163.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#592c1c" data-color-variant="brown"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e234b538c7434f7bcd8d.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e238844808975d2d86b6.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e23c503cbfe539c22829.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#a01720" data-color-variant="red" data-active="false"
                    class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1daaa7cebb438ba8a7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1de0066b4ffb76359ae.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1e1699adad2380f262a.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="black"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e28ed625a4865a11b11b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2913bfaaf38b26a6bcb.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="beige"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2cb204c93aa1a13035f.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2ce3a26c54e599a4cc7.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2d29111e8f6a0b442bd.webp" alt="" />
                    </div>
                  </div>
                </a>
                <div class="group-pagination">
                  <div class="prev-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div class="next-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
                <div class="quick-buy">
                  <span>Quick Buy</span>
                </div>
              </div>
              <div data-attribute="product-info" class="product-info">
                <div data-attribute="product-name" class="product-name">
                  <h3>CARDI B RECOMMENDED</h3>
                  <p>CoolComfort Smoothing Unlined Minimizer Underwire Bra</p>
                </div>
                <div data-attribute="product-price" class="product-price">
                  <div data-attribute="from-text" class="from-text">From</div>
                  <div data-attribute="price-new" class="price-new">$120.99</div>
                  <div data-attribute="price-old" class="price-old">$200.00</div>
                  <div data-attribute="state-product" class="state-product">Sold out</div>
                </div>
                <div class="block-color-variants">
                  <div data-attribute="list-color-variant" class="list-color-variant">
                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="true" data-color-variant="pink"
                        data-label="Pink" data-active="true" data-use-thumbnail="true"
                        style="background:#FFC0CB; --color-variant: #FFC0CB;" class="color-variant active">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp"
                          alt="Pink" />
                      </div>
                      <div class="label-swatches">Pink</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="peach"
                        data-label="Peach" data-active="false" data-use-thumbnail="true"
                        style="background:#d5a596; --color-variant: #d5a596;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp"
                          alt="Peach" />
                      </div>
                      <div class="label-swatches">Peach</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="brown"
                        data-label="Brown" data-active="false" data-use-thumbnail="true"
                        style="background:#592c1c; --color-variant: #592c1c;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp"
                          alt="Brown" />
                      </div>
                      <div class="label-swatches">Brown</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="red"
                        data-label="Red" data-active="false" data-use-thumbnail="true"
                        style="background:#a01720; --color-variant: #a01720;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp"
                          alt="Red" />
                      </div>
                      <div class="label-swatches">Red</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="black"
                        data-label="Black" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp"
                          alt="Black" />
                      </div>
                      <div class="label-swatches">Black</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="beige"
                        data-label="Beige" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp"
                          alt="Beige" />
                      </div>
                      <div class="label-swatches">Beige</div>
                    </div>
                  </div>
                  <div data-attribute="more-color-variant" class="more-color-variant"><span>+ 3 more</span></div>
                </div>
                <div class="block-rating">
                  <div data-attribute="stars" data-value="4" class="stars">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div data-attribute="review-count" class="review-count">10 reviews</div>
                </div>
              </div>
            </div>
          </div>
          <div data-attribute="product-item" class="swiper-slide">
            <div class="wrap-product">
              <div class="block-imgs-product">
                <a href="#" data-attribute="list-img-color-variant" class="wrap-images">
                  <div data-attribute="color-variant" data-color="#FFC0CB" data-color-variant="pink" data-active="true"
                    class="color-variant active">
                    <div class="wrap-img-color active">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df46f249b7a542084dc9.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df4a41a1725b8ce3827f.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#d5a596" data-color-variant="peach"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17bdb2d8fc424333f7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17e89bbe7a9e5772163.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#592c1c" data-color-variant="brown"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e234b538c7434f7bcd8d.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e238844808975d2d86b6.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e23c503cbfe539c22829.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#a01720" data-color-variant="red" data-active="false"
                    class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1daaa7cebb438ba8a7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1de0066b4ffb76359ae.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1e1699adad2380f262a.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="black"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e28ed625a4865a11b11b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2913bfaaf38b26a6bcb.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="beige"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2cb204c93aa1a13035f.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2ce3a26c54e599a4cc7.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2d29111e8f6a0b442bd.webp" alt="" />
                    </div>
                  </div>
                </a>
                <div class="group-pagination">
                  <div class="prev-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div class="next-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
                <div class="quick-buy">
                  <span>Quick Buy</span>
                </div>
              </div>
              <div data-attribute="product-info" class="product-info">
                <div data-attribute="product-name" class="product-name">
                  <h3>CARDI B RECOMMENDED</h3>
                  <p>CoolComfort Smoothing Unlined Minimizer Underwire Bra</p>
                </div>
                <div data-attribute="product-price" class="product-price">
                  <div data-attribute="from-text" class="from-text">From</div>
                  <div data-attribute="price-new" class="price-new">$120.99</div>
                  <div data-attribute="price-old" class="price-old">$200.00</div>
                  <div data-attribute="state-product" class="state-product">Sold out</div>
                </div>
                <div class="block-color-variants">
                  <div data-attribute="list-color-variant" class="list-color-variant">
                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="true" data-color-variant="pink"
                        data-label="Pink" data-active="true" data-use-thumbnail="true"
                        style="background:#FFC0CB; --color-variant: #FFC0CB;" class="color-variant active">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp"
                          alt="Pink" />
                      </div>
                      <div class="label-swatches">Pink</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="peach"
                        data-label="Peach" data-active="false" data-use-thumbnail="true"
                        style="background:#d5a596; --color-variant: #d5a596;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp"
                          alt="Peach" />
                      </div>
                      <div class="label-swatches">Peach</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="brown"
                        data-label="Brown" data-active="false" data-use-thumbnail="true"
                        style="background:#592c1c; --color-variant: #592c1c;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp"
                          alt="Brown" />
                      </div>
                      <div class="label-swatches">Brown</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="red"
                        data-label="Red" data-active="false" data-use-thumbnail="true"
                        style="background:#a01720; --color-variant: #a01720;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp"
                          alt="Red" />
                      </div>
                      <div class="label-swatches">Red</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="black"
                        data-label="Black" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp"
                          alt="Black" />
                      </div>
                      <div class="label-swatches">Black</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="beige"
                        data-label="Beige" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp"
                          alt="Beige" />
                      </div>
                      <div class="label-swatches">Beige</div>
                    </div>
                  </div>
                  <div data-attribute="more-color-variant" class="more-color-variant"><span>+ 3 more</span></div>
                </div>
                <div class="block-rating">
                  <div data-attribute="stars" data-value="4" class="stars">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div data-attribute="review-count" class="review-count">10 reviews</div>
                </div>
              </div>
            </div>
          </div>
          <div data-attribute="product-item" class="swiper-slide">
            <div class="wrap-product">
              <div class="block-imgs-product">
                <a href="#" data-attribute="list-img-color-variant" class="wrap-images">
                  <div data-attribute="color-variant" data-color="#FFC0CB" data-color-variant="pink" data-active="true"
                    class="color-variant active">
                    <div class="wrap-img-color active">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df46f249b7a542084dc9.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df4a41a1725b8ce3827f.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#d5a596" data-color-variant="peach"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17bdb2d8fc424333f7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17e89bbe7a9e5772163.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#592c1c" data-color-variant="brown"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e234b538c7434f7bcd8d.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e238844808975d2d86b6.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e23c503cbfe539c22829.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#a01720" data-color-variant="red" data-active="false"
                    class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1daaa7cebb438ba8a7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1de0066b4ffb76359ae.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1e1699adad2380f262a.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="black"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e28ed625a4865a11b11b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2913bfaaf38b26a6bcb.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="beige"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2cb204c93aa1a13035f.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2ce3a26c54e599a4cc7.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2d29111e8f6a0b442bd.webp" alt="" />
                    </div>
                  </div>
                </a>
                <div class="group-pagination">
                  <div class="prev-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div class="next-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
                <div class="quick-buy">
                  <span>Quick Buy</span>
                </div>
              </div>
              <div data-attribute="product-info" class="product-info">
                <div data-attribute="product-name" class="product-name">
                  <h3>CARDI B RECOMMENDED</h3>
                  <p>CoolComfort Smoothing Unlined Minimizer Underwire Bra</p>
                </div>
                <div data-attribute="product-price" class="product-price">
                  <div data-attribute="from-text" class="from-text">From</div>
                  <div data-attribute="price-new" class="price-new">$120.99</div>
                  <div data-attribute="price-old" class="price-old">$200.00</div>
                  <div data-attribute="state-product" class="state-product">Sold out</div>
                </div>
                <div class="block-color-variants">
                  <div data-attribute="list-color-variant" class="list-color-variant">
                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="true" data-color-variant="pink"
                        data-label="Pink" data-active="true" data-use-thumbnail="true"
                        style="background:#FFC0CB; --color-variant: #FFC0CB;" class="color-variant active">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp"
                          alt="Pink" />
                      </div>
                      <div class="label-swatches">Pink</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="peach"
                        data-label="Peach" data-active="false" data-use-thumbnail="true"
                        style="background:#d5a596; --color-variant: #d5a596;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp"
                          alt="Peach" />
                      </div>
                      <div class="label-swatches">Peach</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="brown"
                        data-label="Brown" data-active="false" data-use-thumbnail="true"
                        style="background:#592c1c; --color-variant: #592c1c;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp"
                          alt="Brown" />
                      </div>
                      <div class="label-swatches">Brown</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="red"
                        data-label="Red" data-active="false" data-use-thumbnail="true"
                        style="background:#a01720; --color-variant: #a01720;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp"
                          alt="Red" />
                      </div>
                      <div class="label-swatches">Red</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="black"
                        data-label="Black" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp"
                          alt="Black" />
                      </div>
                      <div class="label-swatches">Black</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="beige"
                        data-label="Beige" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp"
                          alt="Beige" />
                      </div>
                      <div class="label-swatches">Beige</div>
                    </div>
                  </div>
                  <div data-attribute="more-color-variant" class="more-color-variant"><span>+ 3 more</span></div>
                </div>
                <div class="block-rating">
                  <div data-attribute="stars" data-value="4" class="stars">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div data-attribute="review-count" class="review-count">10 reviews</div>
                </div>
              </div>
            </div>
          </div>
          <div data-attribute="product-item" class="swiper-slide">
            <div class="wrap-product">
              <div class="block-imgs-product">
                <a href="#" data-attribute="list-img-color-variant" class="wrap-images">
                  <div data-attribute="color-variant" data-color="#FFC0CB" data-color-variant="pink" data-active="true"
                    class="color-variant active">
                    <div class="wrap-img-color active">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df46f249b7a542084dc9.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df4a41a1725b8ce3827f.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#d5a596" data-color-variant="peach"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17bdb2d8fc424333f7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17e89bbe7a9e5772163.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#592c1c" data-color-variant="brown"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e234b538c7434f7bcd8d.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e238844808975d2d86b6.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e23c503cbfe539c22829.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#a01720" data-color-variant="red" data-active="false"
                    class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1daaa7cebb438ba8a7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1de0066b4ffb76359ae.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1e1699adad2380f262a.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="black"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e28ed625a4865a11b11b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2913bfaaf38b26a6bcb.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="beige"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2cb204c93aa1a13035f.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2ce3a26c54e599a4cc7.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2d29111e8f6a0b442bd.webp" alt="" />
                    </div>
                  </div>
                </a>
                <div class="group-pagination">
                  <div class="prev-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div class="next-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
                <div class="quick-buy">
                  <span>Quick Buy</span>
                </div>
              </div>
              <div data-attribute="product-info" class="product-info">
                <div data-attribute="product-name" class="product-name">
                  <h3>CARDI B RECOMMENDED</h3>
                  <p>CoolComfort Smoothing Unlined Minimizer Underwire Bra</p>
                </div>
                <div data-attribute="product-price" class="product-price">
                  <div data-attribute="from-text" class="from-text">From</div>
                  <div data-attribute="price-new" class="price-new">$120.99</div>
                  <div data-attribute="price-old" class="price-old">$200.00</div>
                  <div data-attribute="state-product" class="state-product">Sold out</div>
                </div>
                <div class="block-color-variants">
                  <div data-attribute="list-color-variant" class="list-color-variant">
                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="true" data-color-variant="pink"
                        data-label="Pink" data-active="true" data-use-thumbnail="true"
                        style="background:#FFC0CB; --color-variant: #FFC0CB;" class="color-variant active">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp"
                          alt="Pink" />
                      </div>
                      <div class="label-swatches">Pink</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="peach"
                        data-label="Peach" data-active="false" data-use-thumbnail="true"
                        style="background:#d5a596; --color-variant: #d5a596;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp"
                          alt="Peach" />
                      </div>
                      <div class="label-swatches">Peach</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="brown"
                        data-label="Brown" data-active="false" data-use-thumbnail="true"
                        style="background:#592c1c; --color-variant: #592c1c;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp"
                          alt="Brown" />
                      </div>
                      <div class="label-swatches">Brown</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="red"
                        data-label="Red" data-active="false" data-use-thumbnail="true"
                        style="background:#a01720; --color-variant: #a01720;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp"
                          alt="Red" />
                      </div>
                      <div class="label-swatches">Red</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="black"
                        data-label="Black" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp"
                          alt="Black" />
                      </div>
                      <div class="label-swatches">Black</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="beige"
                        data-label="Beige" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp"
                          alt="Beige" />
                      </div>
                      <div class="label-swatches">Beige</div>
                    </div>
                  </div>
                  <div data-attribute="more-color-variant" class="more-color-variant"><span>+ 3 more</span></div>
                </div>
                <div class="block-rating">
                  <div data-attribute="stars" data-value="4" class="stars">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div data-attribute="review-count" class="review-count">10 reviews</div>
                </div>
              </div>
            </div>
          </div>
          <div data-attribute="product-item" class="swiper-slide">
            <div class="wrap-product">
              <div class="block-imgs-product">
                <a href="#" data-attribute="list-img-color-variant" class="wrap-images">
                  <div data-attribute="color-variant" data-color="#FFC0CB" data-color-variant="pink" data-active="true"
                    class="color-variant active">
                    <div class="wrap-img-color active">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df46f249b7a542084dc9.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df4a41a1725b8ce3827f.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#d5a596" data-color-variant="peach"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17bdb2d8fc424333f7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17e89bbe7a9e5772163.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#592c1c" data-color-variant="brown"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e234b538c7434f7bcd8d.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e238844808975d2d86b6.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e23c503cbfe539c22829.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#a01720" data-color-variant="red" data-active="false"
                    class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1daaa7cebb438ba8a7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1de0066b4ffb76359ae.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1e1699adad2380f262a.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="black"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e28ed625a4865a11b11b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2913bfaaf38b26a6bcb.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="beige"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2cb204c93aa1a13035f.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2ce3a26c54e599a4cc7.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2d29111e8f6a0b442bd.webp" alt="" />
                    </div>
                  </div>
                </a>
                <div class="group-pagination">
                  <div class="prev-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div class="next-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
                <div class="quick-buy">
                  <span>Quick Buy</span>
                </div>
              </div>
              <div data-attribute="product-info" class="product-info">
                <div data-attribute="product-name" class="product-name">
                  <h3>CARDI B RECOMMENDED</h3>
                  <p>CoolComfort Smoothing Unlined Minimizer Underwire Bra</p>
                </div>
                <div data-attribute="product-price" class="product-price">
                  <div data-attribute="from-text" class="from-text">From</div>
                  <div data-attribute="price-new" class="price-new">$120.99</div>
                  <div data-attribute="price-old" class="price-old">$200.00</div>
                  <div data-attribute="state-product" class="state-product">Sold out</div>
                </div>
                <div class="block-color-variants">
                  <div data-attribute="list-color-variant" class="list-color-variant">
                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="true" data-color-variant="pink"
                        data-label="Pink" data-active="true" data-use-thumbnail="true"
                        style="background:#FFC0CB; --color-variant: #FFC0CB;" class="color-variant active">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp"
                          alt="Pink" />
                      </div>
                      <div class="label-swatches">Pink</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="peach"
                        data-label="Peach" data-active="false" data-use-thumbnail="true"
                        style="background:#d5a596; --color-variant: #d5a596;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp"
                          alt="Peach" />
                      </div>
                      <div class="label-swatches">Peach</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="brown"
                        data-label="Brown" data-active="false" data-use-thumbnail="true"
                        style="background:#592c1c; --color-variant: #592c1c;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp"
                          alt="Brown" />
                      </div>
                      <div class="label-swatches">Brown</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="red"
                        data-label="Red" data-active="false" data-use-thumbnail="true"
                        style="background:#a01720; --color-variant: #a01720;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp"
                          alt="Red" />
                      </div>
                      <div class="label-swatches">Red</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="black"
                        data-label="Black" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp"
                          alt="Black" />
                      </div>
                      <div class="label-swatches">Black</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="beige"
                        data-label="Beige" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp"
                          alt="Beige" />
                      </div>
                      <div class="label-swatches">Beige</div>
                    </div>
                  </div>
                  <div data-attribute="more-color-variant" class="more-color-variant"><span>+ 3 more</span></div>
                </div>
                <div class="block-rating">
                  <div data-attribute="stars" data-value="4" class="stars">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div data-attribute="review-count" class="review-count">10 reviews</div>
                </div>
              </div>
            </div>
          </div>
          <div data-attribute="product-item" class="swiper-slide">
            <div class="wrap-product">
              <div class="block-imgs-product">
                <a href="#" data-attribute="list-img-color-variant" class="wrap-images">
                  <div data-attribute="color-variant" data-color="#FFC0CB" data-color-variant="pink" data-active="true"
                    class="color-variant active">
                    <div class="wrap-img-color active">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df46f249b7a542084dc9.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df4a41a1725b8ce3827f.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#d5a596" data-color-variant="peach"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17bdb2d8fc424333f7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e17e89bbe7a9e5772163.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#592c1c" data-color-variant="brown"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e234b538c7434f7bcd8d.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e238844808975d2d86b6.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e23c503cbfe539c22829.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#a01720" data-color-variant="red" data-active="false"
                    class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1daaa7cebb438ba8a7b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1de0066b4ffb76359ae.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1e1699adad2380f262a.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="black"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e28ed625a4865a11b11b.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2913bfaaf38b26a6bcb.webp" alt="" />
                    </div>
                  </div>
                  <div data-attribute="color-variant" data-color="#000000" data-color-variant="beige"
                    data-active="false" class="color-variant">
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2cb204c93aa1a13035f.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2ce3a26c54e599a4cc7.webp" alt="" />
                    </div>
                    <div class="wrap-img-color">
                      <img data-attribute="image-color-variant"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2d29111e8f6a0b442bd.webp" alt="" />
                    </div>
                  </div>
                </a>
                <div class="group-pagination">
                  <div class="prev-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div class="next-product">
                    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
                <div class="quick-buy">
                  <span>Quick Buy</span>
                </div>
              </div>
              <div data-attribute="product-info" class="product-info">
                <div data-attribute="product-name" class="product-name">
                  <h3>CARDI B RECOMMENDED</h3>
                  <p>CoolComfort Smoothing Unlined Minimizer Underwire Bra</p>
                </div>
                <div data-attribute="product-price" class="product-price">
                  <div data-attribute="from-text" class="from-text">From</div>
                  <div data-attribute="price-new" class="price-new">$120.99</div>
                  <div data-attribute="price-old" class="price-old">$200.00</div>
                  <div data-attribute="state-product" class="state-product">Sold out</div>
                </div>
                <div class="block-color-variants">
                  <div data-attribute="list-color-variant" class="list-color-variant">
                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="true" data-color-variant="pink"
                        data-label="Pink" data-active="true" data-use-thumbnail="true"
                        style="background:#FFC0CB; --color-variant: #FFC0CB;" class="color-variant active">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1df41d76f24489f9d827b.webp"
                          alt="Pink" />
                      </div>
                      <div class="label-swatches">Pink</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="peach"
                        data-label="Peach" data-active="false" data-use-thumbnail="true"
                        style="background:#d5a596; --color-variant: #d5a596;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1770ca6b60405be98d2.webp"
                          alt="Peach" />
                      </div>
                      <div class="label-swatches">Peach</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="brown"
                        data-label="Brown" data-active="false" data-use-thumbnail="true"
                        style="background:#592c1c; --color-variant: #592c1c;" class="color-variant">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e22f494c0b79e9ef9164.webp"
                          alt="Brown" />
                      </div>
                      <div class="label-swatches">Brown</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="red"
                        data-label="Red" data-active="false" data-use-thumbnail="true"
                        style="background:#a01720; --color-variant: #a01720;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e1d6421dead4f028f1dd.webp"
                          alt="Red" />
                      </div>
                      <div class="label-swatches">Red</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="black"
                        data-label="Black" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e289a75c350c5db949f2.webp"
                          alt="Black" />
                      </div>
                      <div class="label-swatches">Black</div>
                    </div>

                    <div class="item-swatches">
                      <div data-attribute="color-variant" data-sold-out="false" data-color-variant="beige"
                        data-label="Beige" data-active="false" data-use-thumbnail="true"
                        style="background:#000000; --color-variant: #000000;" class="color-variant hidden-item">
                        <img data-attribute="thumbnail-color-variant"
                          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e2c72720fb1d1a78e2db.webp"
                          alt="Beige" />
                      </div>
                      <div class="label-swatches">Beige</div>
                    </div>
                  </div>
                  <div data-attribute="more-color-variant" class="more-color-variant"><span>+ 3 more</span></div>
                </div>
                <div class="block-rating">
                  <div data-attribute="stars" data-value="4" class="stars">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <title>star</title>
                      <path
                        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        fill="currentColor"></path>
                    </svg>
                  </div>
                  <div data-attribute="review-count" class="review-count">10 reviews</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
